import React from 'react';
import { Typography, Box, useMediaQuery, useTheme, Container, alpha } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { BackgroundContainer } from './BackgroundContainer.ts';

const Header: React.FC = () => {
  const isSmallScreen = useMediaQuery('(max-width:600px)');

  const WavyTransition: React.FC = () => {
    const theme = useTheme();
    return (
      <Box sx={{ width: '100%', overflow: 'hidden', lineHeight: 0, position: 'relative', mt: '-2px' }}>
        <svg
          viewBox="0 0 1440 320"
          width="100%"
          height="100"
          preserveAspectRatio="none"
          style={{ display: 'block' }}
        >
          <path
            fill={theme.palette.background.default} // Matches the about section background
            fillOpacity="1"
            d="M0,64L60,80C120,96,240,128,360,144C480,160,600,160,720,144C840,128,960,96,1080,85.3C1200,75,1320,85,1380,90.7L1440,96V320H1380C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320H0Z"
          />
        </svg>
      </Box>
    );
  };

  return (
    <div>
      <BackgroundContainer>
        <Container
          sx={{
            backgroundColor: theme => alpha(theme.palette.background.paper, 0.8),
            borderRadius: 2,
            width: 'fit-content',
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            variant={isSmallScreen ? 'h4' : 'h2'}
            zIndex={1}
            sx={{
              fontFamily: '"Exo 2", sans-serif',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              letterSpacing: '2px',
              lineHeight: 1.2,
            }}
          >
            WELCOME TO 5 STAR LAUNDROMAT
          </Typography>

          <Typography
            variant="subtitle1"
            zIndex={1}
            sx={{
              fontFamily: '"Exo 2", sans-serif',
              fontWeight: '500',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              lineHeight: 1.4,
            }}
          >
            CLEAN CLOTHES, CLEAN LIFE
          </Typography>

          <Box
            sx={{
              mt: 3,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: 2,
              borderRadius: 2,
              backgroundColor: 'primary.main',
              zIndex: 2,
              width: 'fit-content',
            }}
          >
            <StarIcon sx={{ fontSize: isSmallScreen ? '1rem' : '1.5rem', color: 'gold', mx: 0.5 }} />
            <StarIcon sx={{ fontSize: isSmallScreen ? '1rem' : '1.5rem', color: 'gold', mx: 0.5 }} />
            <StarIcon sx={{ fontSize: isSmallScreen ? '1rem' : '1.5rem', color: 'gold', mx: 0.5 }} />
            <StarIcon sx={{ fontSize: isSmallScreen ? '1rem' : '1.5rem', color: 'gold', mx: 0.5 }} />
            <StarIcon sx={{ fontSize: isSmallScreen ? '1rem' : '1.5rem', color: 'gold', mx: 0.5 }} />
          </Box>
        </Container>
      </BackgroundContainer>

      <WavyTransition />

    </div>
  );
};

export default Header;